import { useQuery } from "@apollo/client";
import { CenterResult } from "__legacy/components/CenterResult";
import { CenterSpinner } from "__legacy/components/CenterSpinner";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import { VisitsQuery as VisitsQueryType, VisitsQueryVariables } from "./__generated__/VisitsQuery";

const VisitsQuery = loader("./VisitsQuery.gql");

type VisitsQueryProviderType = (props: {
  children: (data: VisitsQueryType) => ReactNode;
  variables: VisitsQueryVariables;
}) => ReactElement;

export const VisitsQueryProvider: VisitsQueryProviderType = (props) => {
  const { children, variables } = props;

  const { error, loading, data } = useQuery<VisitsQueryType, VisitsQueryVariables>(VisitsQuery, {
    variables,
    fetchPolicy: "cache-and-network",
  });

  if (loading) return <CenterSpinner size="large" />;
  if (error || !data)
    return <CenterResult status="404" title="404" subTitle="Sorry, the page you visited does not exist." />;

  return <Fragment>{children(data)}</Fragment>;
};
